import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import Alert from '../../feature/Alert';
import httpClient from '../../http/HttpRequest';
import { SAVE_CUSTOMER } from '../../data/url';
import { Modal } from 'react-bootstrap';
import FormLayout from '../admin/layout/FormLayout';

export default function CustomerModal(props) {

     const { show, handleClose, vendor } = props;

     const { t } = useTranslation();

     const [formData, setFormData] = useState({
          formTitle: 'Add Customer',
          formFields: [
               { label: 'full_name', id: 'full_name', type: 'text', name: 'full_name', placeholder: 'enter_name', value: '', required: true, className: "col-md-12" },
               { label: 'mobile', id: 'mobile', type: 'number', name: 'mobile', placeholder: 'enter_mobile', value: '', required: true, className: "col-md-12" },
          ],
          formErrors: { full_name: '', mobile: '' },
     });

     const closeModal = () => {
          handleClose(false);
     }

     function handleReset() {
          const updatedFormFields = formData.formFields.map((field) => ({
               ...field,
               value: '',
          }));

          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
               formErrors: {},
          }));
     }
     function handleFieldChange(fieldName, value) {
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     function handleFieldBlur(fieldName, value) {
          validateField(fieldName, value);
     }

     function validateField(fieldName, value) {
          setFormData((prevFormData) => {
               const updatedErrors = { ...prevFormData.formErrors };
               if (fieldName === 'full_name') {
                    updatedErrors.full_name = value.trim() === '' ? 'field_required' : '';
               }
               if (fieldName === 'mobile') {
                    updatedErrors.mobile = '';
                    if (value.trim() === '') {
                         updatedErrors.mobile = 'field_required';
                    } else if (isNaN(Number(value))) {
                         updatedErrors.mobile = 'mobile_sb_containt_number';
                    } else if (value.length !== 10) {
                         updatedErrors.mobile = 'mobile_sb_10_digit';
                    }
               }
               return {
                    ...prevFormData,
                    formErrors: updatedErrors,
               };
          });
          return formData.formErrors;

     }

     function handelSubmit(e) {
          e.preventDefault();
          let post = {};
          let hasErrors = false;
          const updatedFormFields = formData.formFields.map((field) => {
               const allError = validateField(field.name, field.value);
               const error = allError[field.name];
               if (error !== '' && typeof error !== "undefined") {
                    hasErrors = true;
               } else {
                    post[field.name] = field.value;
               }
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          if (!hasErrors) {
               subtmitData(post);
          } else {
               Alert.warning(t('mandetory_fields'));
          }
     }

     const subtmitData = async (post) => {
          post['customer_as_vendor'] = vendor ? 1 : 0;
          const res = await httpClient.post(SAVE_CUSTOMER, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
                    handleClose(false);
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     return (
          <Modal show={show} onHide={closeModal} keyboard={false} backdrop="static">
               <Modal.Header>
                    <Modal.Title>{vendor ? t('add_vendor') : t('add_customer')}</Modal.Title>
                    <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                         <span aria-hidden="true">&times;</span> {/* Close icon */}
                    </button>
               </Modal.Header>
               <Modal.Body>
                    <FormLayout
                         formTitle={formData.formTitle}
                         formFields={formData.formFields}
                         formErrors={formData.formErrors}
                         onFieldChange={handleFieldChange}
                         onFieldBlur={handleFieldBlur}
                         onSubmit={handelSubmit}
                         handleReset={handleReset}
                         isModal={true}
                    />
               </Modal.Body>
          </Modal>
     );
}
